import { useTranslation } from 'react-i18next';

import { SectionContainer } from 'components/shared';
import { PalletBalance } from 'interfaces';
import { Divider } from 'storybook';

import { DamageLossPalletsSummary } from '..';

import styles from './DamagedLostByClientPalletsSummarySection.module.css';

type DamagedLostByClientPalletsSummarySectionProps = {
   damagedByClientPallets: PalletBalance;
   lostOrDestroyedByClientPallets: PalletBalance;
   isSupplierView?: boolean;
   onClickDamagedByClientPalletsDetails: () => void;
   onClickLostOrDestroyedByClientPalletsDetails: () => void;
};

const DamagedLostByClientPalletsSummarySection = ({
   damagedByClientPallets,
   lostOrDestroyedByClientPallets,
   isSupplierView,
   onClickDamagedByClientPalletsDetails,
   onClickLostOrDestroyedByClientPalletsDetails,
}: DamagedLostByClientPalletsSummarySectionProps) => {
   const { t } = useTranslation();

   const viewLabel = isSupplierView
      ? t('damagedLostByClientSummary.supplierViewLabel')
      : t('damagedLostByClientSummary.clientViewLabel');

   return (
      <SectionContainer
         title={t('damagedLostByClientSummary.sectionTitle', {
            label: viewLabel,
         })}
         subtitle={t('damagedLostByClientSummary.sectionSubtitle')}
      >
         <div className={styles.innerContainer}>
            <DamageLossPalletsSummary
               title={t('damagedLostByClientSummary.lostOrDestroyedTitle', { label: viewLabel })}
               damageLossPalletsSummaryData={lostOrDestroyedByClientPallets}
               onClickDetails={onClickLostOrDestroyedByClientPalletsDetails}
               className={styles.damagedLostPalletsByClientSummary}
            />
            <Divider variant="vertical" className={styles.divider} />
            <DamageLossPalletsSummary
               title={t('damagedLostByClientSummary.damagedTitle', { label: viewLabel })}
               damageLossPalletsSummaryData={damagedByClientPallets}
               onClickDetails={onClickDamagedByClientPalletsDetails}
               className={styles.damagedLostPalletsByClientSummary}
            />
         </div>
      </SectionContainer>
   );
};

export default DamagedLostByClientPalletsSummarySection;
